import { getUploadedIdentifierForRow } from './identifierDisplay';

const firstNonBlank = (...values) => {
    for (const value of values) {
        if (value == null) continue;
        const normalized = String(value).trim();
        if (normalized) return normalized;
    }
    return '';
};

export const normalizeCogniveId = (value) => firstNonBlank(value) || null;

const isAcceptedWatchlistRow = (row) => {
    const appReadiness = firstNonBlank(row?.app_readiness_status).toLowerCase();
    // NULL/absent is retained for legacy accepted watchlist rows. Any explicit
    // non-ready state is not yet a usable watchlist security and stays out of
    // this selector.
    return !appReadiness || appReadiness === 'ready';
};

export function buildWatchlistSecurityOptions(industries = []) {
    const byCogniveId = new Map();

    (Array.isArray(industries) ? industries : []).forEach((row) => {
        const cogniveId = normalizeCogniveId(row?.cognive_id);
        if (!cogniveId || !isAcceptedWatchlistRow(row) || byCogniveId.has(cogniveId)) return;

        const uploadedIdentifier = getUploadedIdentifierForRow(row);
        byCogniveId.set(cogniveId, {
            id: cogniveId,
            cognive_id: cogniveId,
            inbound_id_type: row?.inbound_id_type ?? row?.identifier_type ?? null,
            inbound_id_value: row?.inbound_id_value ?? row?.identifier ?? null,
            identifier: uploadedIdentifier.value || '',
            identifier_type: uploadedIdentifier.type || '',
            msi_listing_label: row?.msi_listing_label ?? null,
            uploaded_ticker: row?.uploaded_ticker ?? null,
            ticker: firstNonBlank(
                row?.msi_listing_label?.ticker,
                row?.msi_ticker,
                row?.ticker,
            ),
            company_name: firstNonBlank(
                row?.msi_listing_label?.security_name,
                row?.company_name,
                row?.security_name,
                row?.name,
            ),
            country: firstNonBlank(row?.country, row?.country_code),
            source: row,
        });
    });

    return Array.from(byCogniveId.values());
}

export function buildPosSizingDraftRows(watchlistRows = [], existingRows = []) {
    const existingIds = new Set(
        (Array.isArray(existingRows) ? existingRows : [])
            .map((row) => normalizeCogniveId(row?.cognive_id))
            .filter(Boolean),
    );

    return buildWatchlistSecurityOptions(watchlistRows)
        .filter((option) => !existingIds.has(option.cognive_id))
        .map((option) => {
            const source = option.source || {};
            return {
                id: option.cognive_id,
                cognive_id: option.cognive_id,
                ticker: option.ticker,
                company_name: option.company_name,
                security_name: option.company_name,
                country: option.country,
                inbound_id_type: source?.inbound_id_type ?? source?.identifier_type ?? null,
                inbound_id_value: source?.inbound_id_value ?? source?.identifier ?? null,
                msi_listing_label: source?.msi_listing_label ?? null,
                price: source?.price ?? null,
                dollar_adtv: source?.dollar_adtv ?? null,
                trade_idea: null,
                pos_gmv_dollar: null,
                custom_liquidity: null,
                custom_idio_vol: null,
                isNewRow: true,
                toDelete: false,
            };
        });
}
